module.exports = __webpack_public_path__ + "r-v3/img/highlighter_blue.760f0555.svg";